import React from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

const ConfirmationDialog = ({
  title,
  dialogContent,
  handleOpen,
  handleClose,
  handleSubmit
}) => {
  const actions = [
    <FlatButton label='Cancel' primary={true} onClick={handleClose} />,
    <FlatButton label='Submit' primary={true} onClick={handleSubmit} />
  ]

  return (
    <Dialog
      title={title}
      actions={actions}
      modal={false}
      open={handleOpen}
      onRequestClose={handleClose}
    >
      {dialogContent}
    </Dialog>
  )
}

export default ConfirmationDialog



/** WEBPACK FOOTER **
 ** ./src/components/Dialog/Dialog.js
 **/